import * as THREE from "three";

import { ASSET_TYPE, BearAsset } from "./AssetConst";
import { Object3DManager } from "./assets/Object3DManager";
import { PlanarAssetManager } from "./assets/PlanarAssetManager";
import { computedAsset } from "./assets/AssetManager";
import { SceneManager } from "../SceneManager";
import { BuildMediaUrl } from "../ArgoUtils";

//enum for asset type ids

export class BearManager {
    private fMarkerWidth: any;
    private fMarkerHeight: any;
    //private fMarkerWidthReal:any
    //private fMarkerHeightReal:any
    private scaleMult: number;
    private scaleDivider: number;
    private manager: any;
    private marker: THREE.Object3D;

    constructor(marker: THREE.Object3D) {
        this.marker = marker;
        (this.fMarkerWidth = null),
            (this.fMarkerHeight = null),
            (this.manager = new THREE.LoadingManager()),
            (this.scaleMult = 320);
        this.scaleDivider = null;
    }

    show(asset: any, _show: boolean) {
        asset.visible = _show;
    }

    /**
     * @param {object} marker marker as given by bear API
     * creates plane with marker and init dimensions used by assets
     */
    fnLoadMarker(marker) {
        return new Promise((resolve, reject) => {
            let ratio = 1;
            const iw = marker.iw;
            const ih = marker.ih;

            ratio = iw > ih ? iw / ih : ih / iw;

            this.fMarkerWidth = iw > ih ? 1 : 1 / ratio;
            this.fMarkerHeight = ih > iw ? 1 : 1 / ratio;
            const videoMaxSize = 640;
            this.fMarkerHeight =
                Math.max(iw, ih) > videoMaxSize
                    ? Math.round(this.fMarkerHeight * videoMaxSize)
                    : ih;
            this.fMarkerWidth =
                Math.max(iw, ih) > videoMaxSize ? Math.round(this.fMarkerWidth * videoMaxSize) : iw;

            this.scaleDivider = ih < iw ? this.scaleMult : this.scaleMult * ratio;

            const geometry = new THREE.PlaneGeometry(this.fMarkerWidth, this.fMarkerHeight);
            const material = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                side: THREE.DoubleSide,
                depthWrite: true,
                depthTest: true
            });

            //material.wireframe = true;
            const plane = new THREE.Mesh(geometry, material);
            plane.name = "marker";
            plane.position.x = 0;
            plane.position.y = 0;
            plane.position.z = -0.01;
            resolve(plane);
        });
    }

    /**
     * @param {BearAsset[]} assets array of assets as given by api
     * perform instant fullscreen action of first fullscreen asset
     */
    showFullScreenAsset(asset: BearAsset): void {
        //console.log(asset)
        if (asset) {
            const url = this.getAssetS1Url(asset);
            //console.log("fnAutoplayFullScreenAsset "+asset.asset_type)
            if (asset.type_name == "Video") {
                let videoUrl: string;
                const request = new XMLHttpRequest();
                request.open("GET", url);
                request.onload = () => {
                    if (request.status == 200) {
                        videoUrl = this.getVideoUrlFromVideoWebview(request.response);
                        asset.videoUrl = videoUrl;
                        //this.webArgo.createFullScreenIframe(videoUrl,true)
                    } else {
                        console.error(request.status + "/" + request.statusText);
                    }
                };
                request.onerror = e => {
                    console.error(e);
                };

                request.send();
            } else {
                //this.webArgo.createFullScreenIframe(url,false)
            }

            //window.open(url,"_blank");
        }
    }

    /**
     * @param {object[]} assets array of assets as given by api
     * return promise of array of asset meshes
     */
    fnLoadAssets(
        assets: BearAsset[],
        marker,
        loaderTexture,
        sId: number,
        onSuccess: Function,
        onError: Function
    ): Promise<Array<computedAsset>> {
        return new Promise(resolve => {
            const promises = [];
            assets.forEach(asset => {
                // @see https://github.com/bear2b/argo_webar_library_ts/blob/dev/src/components/sceneComponent.ts#L638
                asset.sId = sId;

                //asset.placeHolder = self.fnCreatePlaceholderAsset(asset, loaderTexture);

                //marker.add(asset.placeHolder);

                const newPromise = new Promise((success, err) => {
                    let isScript = false;
                    if (typeof asset.s1 !== "undefined") {
                        const leftURLSide = asset.s1.toLowerCase().split("?")[0];
                        isScript =
                            asset.asset_type == ASSET_TYPE.URL &&
                            leftURLSide.substring(leftURLSide.length - 3, leftURLSide.length) ==
                                ".js";
                    }

                    if (isScript) {
                        const leftURLSide = asset.s1.toLowerCase().split("?")[0];
                        if (
                            leftURLSide.substring(leftURLSide.length - 3, leftURLSide.length) ==
                            ".js"
                        ) {
                            this.load_script_promise(leftURLSide)
                                .then(ret => {
                                    onSuccess(ret);
                                    success(ret);
                                })
                                .catch(() => {
                                    onError(asset);
                                });
                        }
                    } else {
                        this.fnLoadAsset(asset)
                            .then(ret => {
                                const m = ret as any;
                                m.onClick = this.onAssetClick.bind(this);
                                m.traverse(function(node) {
                                    node.onClick = m.onClick;
                                    node.originalAsset = m.originalAsset;
                                });
                                onSuccess(ret);
                                success(ret);
                            })
                            .catch(err => {
                                console.error(err);
                                onError(asset);
                            });
                    }
                });
                promises.push(newPromise);
            });
            Promise.all(promises).then(ret => {
                console.log("BAM: done");
                resolve(ret);
            });
        });
    }

    // eslint-disable-next-line @typescript-eslint/camelcase
    load_script_promise(url) {
        return new Promise((resolve, reject) => {
            //check if not already loaded
            if (
                Array.from(document.getElementsByTagName("script")).filter(s => s.src == url)
                    .length > 0
            ) {
                return;
            }

            const head = document.getElementsByTagName("head")[0];
            const script = document.createElement("script");
            script.setAttribute("argo", "custom");
            (script as any).originalAsset = {
                sId: -1
            };
            script.type = "text/javascript";
            script.onload = () => {
                resolve(script);
            };
            script.onerror = () => {
                console.error("error loading " + url);
                reject(script);
            };
            script.src = url;
            head.appendChild(script);
        });
    }

    /**
     * @param {object} asset asset as given by the api
     * return promise of asset mesh
     */
    fnLoadAsset(asset: BearAsset) {
        return new Promise((resolve, reject) => {
            if (asset.sId == SceneManager.sId) {
                if (asset.asset_type !== ASSET_TYPE.OBJECT3D) {
                    const planarAssetManager = new PlanarAssetManager(
                        this.fMarkerWidth,
                        this.fMarkerHeight
                    );
                    planarAssetManager
                        .getComputedAsset(asset)
                        .then(plane => {
                            resolve(plane);
                        })
                        .catch(err => {
                            console.error(err);
                            throw new Error("failed to load planar model " + asset.name);
                        });
                } else {
                    //3dModel
                    const object3DManager = new Object3DManager(
                        this.fMarkerWidth,
                        this.fMarkerHeight
                    );
                    object3DManager
                        .getComputedAsset(asset)
                        .then(zipRes => {
                            resolve(zipRes);
                        })
                        .catch(err => {
                            throw new Error("failed to load 3d model " + asset.name);
                        });
                }
            } else {
                //console.log("too late "+asset.sId+" "+asset.name)
                resolve(null);
            }
        });
    }

    onAssetClick(assetMesh) {
        if (!assetMesh || !assetMesh.originalAsset) {
            console.error("ERROR : asset clicked doesn't exist.");
            return;
        }

        const asset = assetMesh.originalAsset;

        const clickevent = new CustomEvent("argo_click", {
            detail: { id: asset.id, name: asset.name }
        });
        window.dispatchEvent(clickevent);

        let url = this.getAssetS1Url(asset);
        switch (asset.asset_type) {
            case ASSET_TYPE.VCARD:
                url = url.substring(url.indexOf(",") + 1);
                url = URL.createObjectURL(new Blob([url], { type: "text/vcard" }));
                window.open(url, "_blank");
                break;
            case ASSET_TYPE.VIDEO:
                if (asset.domElement.paused || asset.domElement.ended) {
                    //  we toggle play/pause
                    asset.domElement.play();
                } else {
                    asset.domElement.pause();
                }
                if (assetMesh.videoPlane != undefined) {
                    assetMesh.parent.attach(assetMesh.videoPlane);
                    assetMesh.videoPlane.visible = true;
                    assetMesh.visible = false;
                }
                break;
            case ASSET_TYPE.AUDIO: //  we toggle play/pause
                if (asset.domElement.paused) {
                    asset.domElement.play();
                } else {
                    asset.domElement.pause();
                }

                break;
            case ASSET_TYPE.IMAGE:
                break;
            case ASSET_TYPE.WEBVIEW:
                this.showFullScreenAsset(asset);
                break;
            case ASSET_TYPE.SHARE:
                //we use any as a TS hack
                // eslint-disable-next-line no-case-declarations
                const windownavigator: any = navigator;
                if (windownavigator.share !== undefined) {
                    try {
                        windownavigator.share({
                            title: asset.url_title,
                            text: asset.url_desc,
                            url: asset.url ? asset.url : url
                        });
                    } catch (e) {
                        console.error("cannot share asset, but your device supports it.", e);
                        window.open(asset.url ? asset.url : url, "_blank");
                    }
                } else {
                    window.open(asset.url ? asset.url : url, "_blank");
                }
                break;
            case ASSET_TYPE.OBJECT3D: //we play anim
                if (
                    assetMesh.mixer != undefined ||
                    (assetMesh.parent != undefined && assetMesh.parent.mixer != undefined)
                ) {
                    const mixer = assetMesh.mixer || assetMesh.parent.mixer;
                    const clips = assetMesh.animations || assetMesh.parent.animations;
                    clips.forEach(clip => {
                        mixer
                            .clipAction(clip)
                            .reset()
                            .play();
                    });
                }
                break;
            default:
                if (url && url != "") {
                    window.open(url, "_blank");
                }
                break;
        }
        const otherAssetName = asset.name.split("@@")[1]; // let's check action and target inst
        if (otherAssetName != undefined) {
            const action = asset.name.split("@@")[2];
            const isFS = action == "fs";
            const otherAsset = this.marker.children.filter(
                (a: any) => a.originalAsset != undefined && a.originalAsset.name == otherAssetName
            );
            if (otherAsset.length > 0) {
                url = this.getAssetS1Url((otherAsset[0] as any).originalAsset);
                if (isFS == false) this.onAssetClick(otherAsset[0]);
                else {
                    if (
                        (otherAsset[0] as any).originalAsset.asset_type == ASSET_TYPE.WEBVIEW &&
                        (otherAsset[0] as any).originalAsset.type_name == "Video"
                    ) {
                        let videoUrl: string;
                        const request = new XMLHttpRequest();
                        request.open("GET", url);
                        request.onload = () => {
                            if (request.status == 200) {
                                videoUrl = this.getVideoUrlFromVideoWebview(request.response);
                                asset.videoUrl = videoUrl;
                                //this.webArgo.createFullScreenIframe(videoUrl,true)
                            } else {
                                console.error(request.status + "/" + request.statusText);
                            }
                        };
                        request.onerror = e => {
                            console.error(e);
                        };

                        request.send();
                    } else if (
                        (otherAsset[0] as any).originalAsset.asset_type == ASSET_TYPE.VIDEO
                    ) {
                        // self.webArgo.createFullScreenIframe(url,true)
                    } else {
                        // self.webArgo.createFullScreenIframe(url,false)
                    }
                }
            }
            this.onAssetClick(asset.attachedAsset);
        }
    }
    /**
     * @param {BearAsset} asset bearAsset
     * @returns {string} usable URL for opening in a browser
     */
    private getAssetS1Url(asset: BearAsset): string {
        let url = asset.s1;
        if (
            url &&
            url != "" &&
            asset.asset_type != ASSET_TYPE.IMAGE &&
            asset.asset_type != ASSET_TYPE.OBJECT3D
        ) {
            if (asset.asset_type == ASSET_TYPE.PHONE) {
                url = "tel:" + url;
            } else if (asset.asset_type == ASSET_TYPE.EMAIL) {
                url = "mailto:" + url;
            } else if (asset.asset_type == ASSET_TYPE.VCARD) {
                url = "data:text/x-vcard," + url;
            } else if (
                asset.asset_type != ASSET_TYPE.URL &&
                asset.asset_type != ASSET_TYPE.WEBVIEW
            ) {
                url = BuildMediaUrl(url);
            } else if (asset.asset_type != ASSET_TYPE.WEBVIEW && asset.type_name == "Video") {
                //?!! yes this way
                //url=this.getVideoUrlFromVideoWebview(asset.s1)
            }
        }
        return url;
    }
    private getVideoUrlFromVideoWebview(webviewurl: string): string {
        let t = webviewurl;
        /*  const parser = new DOMParser();
    let xmlDoc = parser.parseFromString(request.response,"text/xml");
    Array.from(xmlDoc.getElementsByTagName("video")).forEach(s=>{
        videoUrl=s.src
    }) */
        let i = t.search("src");
        t = t.substring(i + 13, t.length);
        i = t.search('"');
        return "https://api.bear2b.com/media/" + t.substring(0, i);
    }
}
